import { TableCell } from "@/components/ui/table";
import {
  formatUsageBillingCurrency,
  formatUsageBillingQuantity,
  getUsageEventSourceLabel,
  type UsageBillingEvent,
} from "./usage-billing-format";
import { formatUsageBillingDateTime } from "./usage-billing-time";

export type { UsageBillingEvent };

type UsageBillingEventRowCellsProps = {
  event: UsageBillingEvent;
};

// Cells shared by every table that lists usage events: the inline preview
// and the full per-unit event list both start from this set and append
// their own trailing columns.
export function UsageBillingEventRowCells({
  event,
}: UsageBillingEventRowCellsProps) {
  return (
    <>
      <TableCell>{formatUsageBillingDateTime(event.occurredAt)}</TableCell>
      <TableCell>{event.categoryDisplayName}</TableCell>
      <TableCell className="text-right tabular-nums">
        {formatUsageBillingQuantity(event.quantity)}
      </TableCell>
      <TableCell className="text-right tabular-nums">
        {event.basisAmount
          ? formatUsageBillingCurrency(event.basisAmount)
          : "—"}
      </TableCell>
      <TableCell>
        {getUsageEventSourceLabel(event)}
        {event.voidedAt && event.voidReason && (
          <span className="ml-2 text-xs">(voided: {event.voidReason})</span>
        )}
      </TableCell>
    </>
  );
}
